import React, { Component } from 'react';
import moment from 'moment';
import { Guardian } from '@xaamin/guardian';
import { Col, Row } from 'react-bootstrap';

import { Auth, Http } from '../../support';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import UsuarioProfileForm from '../../app/usuarios/upsert/components/UsuarioProfileForm';

class UserProfile extends Component {

  state = {
    data: {}
  }

  constructor(props) {
    super(props);

    const data = Auth.getUser();

    this.state ={
      data
    };
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
        return;
    };
}

  handleOnChange = (event) => {
    this.setState({
      ...event,
      error: undefined,
      result: undefined
    });
  }

  handleOnSubmit = async () => {
    const { data: { email, nombre } } = this.state;

    this.setState({
      busy: true,
      error: undefined
    });

    let response;

    try {
      const headers = {
        'X-Tenancy': 'fa/live'
      }

      const params = {
        include: ['cliente', 'empresa', 'permissions']
      }

      const body = {
        email,
        nombre,
      }

      response = await Http.put(`auth/me`, body, {
        headers,
        params
      });

      this.setState({
        response
      });
    } catch (error) {
      this.setState({
        error: error.data || error
      });
    } finally {
      this.setState({
        busy: false
      });
    }

    if (!!response && !!this.props.onComplete) {
      this.props.onComplete(response.data);
    }
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.setState({
        error: undefined
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          variant="inline"
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { data, isValid, busy, error, response } = this.state;

    if (!data && !data.nombre) {
      return <Loading />
    }

    return (
      <>
        <Row>
          <Col xs={ 12 } sm={ 12 } md={ 5 } lg={ 5 }>
            <UsuarioProfileForm
              data={ data }
              onFormDataChange={ this.handleOnChange }
              onAction={ this.handleOnAction }
            />
          </Col>
        </Row>

        { !!response && (
            <p className="text-info">
              Actualizado por última vez a las { moment(response.data.updated_at).format('hh:mm:ss A') }
            </p>
          )
        }

        { !!error && this.renderError() }

        { Guardian.allows('perfil.editar') && (
          <div>
            <LoadingButton
              disabled={ busy || !isValid }
              loading={ busy }
              onClick={ this.handleOnSubmit }
            >
              Guardar
            </LoadingButton>
          </div>
        )}
      </>
    );
  }
}


export default UserProfile;